import { useMemo } from 'react';
import { ChatModuleActiveRule as ActiveRule, ChatModuleType } from 'app/copied/models/ChatModules';

import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export const offlineModules = [ChatModuleType.TAIlor, ChatModuleType.VirtualAssistant];

export function useOfflineModulesAvailable() {
  const { data: helpCenter } = useFetchHelpCenter();
  const nnOffline = !helpCenter?.nurses_are_online;

  return !!useMemo(
    () =>
      helpCenter?.modules?.some((module) => {
        const isOfflineModule = offlineModules.includes(module.module_type);
        const isAlwaysActive = ActiveRule.ALWAYS === module.is_active_rule;
        const isActiveOffline = ActiveRule.NN_OFFLINE === module.is_active_rule;

        return isOfflineModule && (isAlwaysActive || (isActiveOffline && nnOffline));
      }),
    [helpCenter, nnOffline]
  );
}
